// extracted by mini-css-extract-plugin
module.exports = {"formPet":"FormPet_formPet_ztsYP","isStyleDingBeauty":"FormPet_isStyleDingBeauty_3w308"};